import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { MyaccountAccountInfoComponent } from './myaccount-account-info.component';

@NgModule({
  declarations: [MyaccountAccountInfoComponent],
  imports: [
    CommonModule,
    I18nModule,
    MatTooltipModule,
    RouterModule,
    UrlModule,
    SharedModule,
    TooltipTextModule,
    IconModule,
    MatIconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyAccountAccountInfoAccountInfoFlexComponent: {
          component: MyaccountAccountInfoComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountAccountInfoModule {}
